
import { defineComponent } from "vue";
import EventBusService from "@/services/EventBusService";
import { RecordIdentifier } from "@/data/global";
import { Appointment } from "@/data/appointments";
import { AppointmentDetailsOpenEvent } from "@/data/eventbus";
import AppointmentDetailModal from "@/components/modals/AppointmentDetailModal.vue";

declare interface AppointmentDetailModalGlobalInjectorData {
    modalShown: boolean,
    appointment: Appointment|RecordIdentifier|null,
    closeOnEnrollmentChange: boolean,
}

export default defineComponent({
    name: 'AppointmentDetailModalGlobalInjector',
    components: {
        AppointmentDetailModal,
    },
    props: {

    },
    computed: {

    },
    data() : AppointmentDetailModalGlobalInjectorData {
        return {
            modalShown: false,
            appointment: null,
            closeOnEnrollmentChange: false,
        };
    },
    methods: {
        openModal(event: AppointmentDetailsOpenEvent) {
            this.appointment = event.appointment;
            this.modalShown = true;
            this.closeOnEnrollmentChange = event?.closeOnEnrollmentChange || false;
        },
        onEnrollmentStatusChange() {
            if( this.closeOnEnrollmentChange ) {
                this.modalShown = false;
            }
        },
    },
    watch: {

    },
    mounted() {
        EventBusService.$on('modals.appointment.details.open', this.openModal);
    },
    beforeUnmount() {
        EventBusService.$off('modals.appointment.details.open', this.openModal);
    }
});
